import util from '@/libs/util'

const post = util.ajax.post

export const jobUrls = [
  // 查询
  '/accountJob/list'
]

export const job = {}

job.listJob = function (params) {
  return post('/accountJob/list', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/account/job.js